var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.config
    ? _c("div", { staticClass: "tc-page-container" }, [
        _c("div", { attrs: { id: "aimo-layout" } }, [
          _c("div", { attrs: { id: "aimo-left" } }, [
            _c("div", { staticClass: "aimo-left-header" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "aimo-header-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-small is-outlined",
                    attrs: { title: _vm.strings.startNewSession },
                    on: { click: _vm.clearChat },
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.strings.clear))]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button is-small is-outlined",
                    attrs: {
                      id: "rail-toggle-btn",
                      title: _vm.strings.sessionsAndInfo,
                    },
                    on: {
                      click: function ($event) {
                        _vm.railOpen = true
                      },
                    },
                  },
                  [_vm._m(2)]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { ref: "messagesWrap", staticClass: "chat-messages-wrap" },
              [
                _vm._l(_vm.displayMessages, function (message, index) {
                  return _c("message-bubble", {
                    key: index,
                    attrs: {
                      message: message,
                      "show-mid-steps": _vm.config.showMidSteps,
                      "rate-url-template": _vm.config.urls.chatlogRateTemplate,
                      strings: _vm.strings,
                      "map-config": _vm.config.map,
                      clock: _vm.clockTick,
                      "session-id": _vm.currentSessionId,
                      "artifact-url-template":
                        _vm.config.urls.deepArtifactTemplate,
                      "is-last": index === _vm.displayMessages.length - 1,
                      "can-approve": !_vm.busy,
                    },
                    on: {
                      rated: function ($event) {
                        return _vm.onRated(message, $event)
                      },
                      "approve-plan": _vm.approvePlan,
                    },
                  })
                }),
                _vm._v(" "),
                _vm.liveSteps.length
                  ? _c("steps-collapsible", {
                      attrs: {
                        steps: _vm.liveSteps,
                        label: _vm.strings.analysisSteps,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.liveDeepSteps.length
                  ? _c("deep-steps", {
                      attrs: {
                        steps: _vm.liveDeepSteps,
                        label: _vm.strings.investigationSteps,
                        live: true,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.streamingMessage
                  ? _c("message-bubble", {
                      attrs: {
                        message: _vm.streamingMessage,
                        streaming: true,
                        "show-mid-steps": _vm.config.showMidSteps,
                        "rate-url-template":
                          _vm.config.urls.chatlogRateTemplate,
                        strings: _vm.strings,
                        "map-config": _vm.config.map,
                        clock: _vm.clockTick,
                        "session-id": _vm.currentSessionId,
                        "artifact-url-template":
                          _vm.config.urls.deepArtifactTemplate,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showTyping
                  ? _c("div", { staticClass: "chat-message is-ai" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("div", { staticClass: "typing-indicator" }, [
                        _c("div", { staticClass: "typing-dot" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "typing-dot" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "typing-dot" }),
                        _vm._v(" "),
                        _vm.typingStatus
                          ? _c("span", { staticClass: "typing-status" }, [
                              _vm._v(_vm._s(_vm.typingStatus)),
                            ])
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _vm.errorMessage
              ? _c("div", { staticClass: "chat-error" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.errorMessage))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "chat-input-wrap" }, [
              _vm.lockedToFast
                ? _c(
                    "div",
                    {
                      staticClass:
                        "notification is-warning is-light retired-conversation",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.strings.retiredConversation) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "field has-addons",
                  staticStyle: { "margin-bottom": "0" },
                },
                [
                  _c("div", { staticClass: "control is-expanded" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputText,
                          expression: "inputText",
                        },
                      ],
                      ref: "input",
                      staticClass: "textarea",
                      attrs: {
                        id: "chat-input",
                        placeholder: _vm.strings.inputPlaceholder,
                        rows: "1",
                        autofocus: "",
                        disabled: _vm.lockedToFast,
                      },
                      domProps: { value: _vm.inputText },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.inputText = $event.target.value
                          },
                          _vm.autosize,
                        ],
                        keydown: _vm.onInputKeydown,
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-primary",
                        class: { "is-stop-mode": _vm.busy },
                        staticStyle: { height: "100%" },
                        attrs: {
                          id: "btn-send",
                          disabled: _vm.lockedToFast && !_vm.busy,
                          title: _vm.busy ? _vm.strings.stop : _vm.strings.send,
                        },
                        on: {
                          click: function ($event) {
                            _vm.busy ? _vm.stopMessage() : _vm.sendMessage()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon" }, [
                          _c("i", {
                            class: _vm.busy
                              ? "fas fa-stop"
                              : "fas fa-paper-plane",
                          }),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "chat-input-tools" }, [
                _c("input", {
                  ref: "fileInput",
                  staticStyle: { display: "none" },
                  attrs: { type: "file", accept: ".csv,.xlsx,.xls" },
                  on: { change: _vm.onFileChosen },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button is-small is-rounded",
                    attrs: {
                      type: "button",
                      disabled: _vm.busy || _vm.lockedToFast,
                      title: _vm.attachTitle,
                    },
                    on: { click: _vm.chooseFile },
                  },
                  [_vm._m(5)]
                ),
                _vm._v(" "),
                _vm.pendingFile
                  ? _c(
                      "span",
                      {
                        staticClass: "tag is-info is-light",
                        attrs: { title: _vm.strings.attachedFile },
                      },
                      [
                        _c("i", { staticClass: "fas fa-file-excel" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.pendingFile.name) +
                            "\n                        "
                        ),
                        _c("button", {
                          staticClass: "delete is-small",
                          attrs: {
                            type: "button",
                            title: _vm.strings.removeAttachment,
                          },
                          on: {
                            click: function ($event) {
                              _vm.pendingFile = null
                            },
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.deepActive
                  ? _c(
                      "button",
                      {
                        staticClass: "button is-small is-rounded",
                        class: { "is-info": _vm.planFirstActive },
                        attrs: {
                          type: "button",
                          disabled: _vm.busy || _vm.modeLocked,
                          title: _vm.planFirstTitle,
                        },
                        on: {
                          click: function ($event) {
                            _vm.planFirst = !_vm.planFirst
                          },
                        },
                      },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.strings.planFirst))]),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "help has-text-grey",
                  staticStyle: { "margin-top": "0.35rem" },
                },
                [
                  _vm._m(7),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.strings.helpText) +
                      "\n                "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "rail-backdrop",
            class: { "is-visible": _vm.railOpen },
            on: {
              click: function ($event) {
                _vm.railOpen = false
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              class: { "rail-open": _vm.railOpen },
              attrs: { id: "aimo-right" },
            },
            [
              _c("session-sidebar", {
                attrs: {
                  latest: _vm.sessions.latest,
                  favorites: _vm.sessions.favorites,
                  "current-session-id": _vm.currentSessionId,
                  "pending-title": _vm.pendingSessionTitle,
                  strings: _vm.strings,
                },
                on: {
                  select: _vm.loadSession,
                  "toggle-favorite": _vm.toggleFavorite,
                  delete: _vm.deleteSession,
                },
              }),
              _vm._v(" "),
              _c("connections-panel", {
                attrs: {
                  connections: _vm.config.connections,
                  "manage-url": _vm.config.mcpServersUrl,
                  strings: _vm.strings,
                },
              }),
              _vm._v(" "),
              _c("model-panel", {
                attrs: {
                  models: _vm.pickerModels,
                  "selected-model-id": _vm.selectedModelId,
                  disabled: _vm.busy || _vm.currentSessionId !== null,
                  "ai-models-url": _vm.config.aiModelsUrl,
                  strings: _vm.strings,
                },
                on: { select: _vm.onSelectModel },
              }),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("h2", [
      _c("i", { staticClass: "fas fa-comments" }),
      _vm._v(" AIMO"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-times" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-bars" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "bubble-avatar" }, [
      _c("i", { staticClass: "fas fa-comments" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-exclamation-circle" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-paperclip" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-clipboard-list" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-comments" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }